<template>
  <div class="trust">
    <div class="container">
      <h2 >Ils m'ont fait confiance</h2>
      <div  class="trust__list">
          <UCarousel
            v-slot="{ item }"
            loop
            :arrows="showArrows"
            :items="collabs"
            class="w-full mx-auto"
            :ui="carouselUi"
          >
            <a :href="item.acf.lien_site" target="_blank" :title="`voir le site de ${item.title.rendered}`">
              <NuxtImg 
                :src="item.acf.logo_collab.sizes.medium" 
                :alt="item.acf.logo_collab.alt"
                :class="imageClass"
                format="webp"
                lazy="loading"
              />
            </a>
          </UCarousel>
      </div>
    </div>
  </div>
</template>

<script setup lang='ts'>
import type { ClientData } from '~/types/clients'

const { getclient } = useWordpressApi()
const collabs: ClientData[] = await getclient()

// @ts-ignore
const viewport = useViewport()

const isMobile = computed(() => viewport.isLessOrEquals('mobileWide'))
const isTablet = computed(() => viewport.isGreaterThan('mobileWide') && viewport.isLessThan('desktop'))
const showArrows = computed(() => {
  if (isMobile.value) {
    return true
  }
  if( isTablet.value){
    if (collabs.length > 3){
        return true
    }
  }
  return collabs.length > 6
})

const carouselUi = computed(() => {
  if (isMobile.value) {
    return {
      item: 'basis-full flex items-center justify-center max-h-[100px]',
      container: 'gap-0'
    }
  }
  if(isTablet.value){
    return{
         item: 'basis-1/3  shrink-0 flex justify-center  ',
      container: 'gap-0'
    }
  }

  return {
    item: 'basis-1/5',
    container: 'gap-0'
  }
})

const imageClass = computed(() => {
  if (isMobile.value) {
    return 'w-full h-auto max-w-[150px] max-h-[150px] object-contain'
  }
    if (isTablet.value) {
    return ' w-[150px] h-[150px] object-contain'
  }
  return 'h-auto object-contain w-[150px] h-[150px]'
})
</script>
<style lang="scss">
    .trust{
        width: 100%;
        padding-block: 50px;
        @media screen and (max-width:1035px) {
            height: 300px;
            padding-block:25px;
        }
   
    
    &__list{
        padding: 20px 0; 
        button{
            @media screen and (max-width:1035px) {
                &[aria-label="Prev"]{
                    left: 20px;
                }
                &[aria-label="Next"]{
                    right: 20px;
                }
            }
        }
         div{
            height: 100%;
            display: flex;
            align-items: center;
        }
    }
    }
</style>